import { PrefaReglasInfo } from './prefaReglasinfo.model';
import { VilaxInfo } from './vilaxInfo.model';
import { GlassInfo } from './glassInfo.model';

export class model8040Info extends PrefaReglasInfo {
    vContramarco: boolean;
    vRampa: number; 

    constructor() {
        super();
        this.vModelo = '8040';
        this.vCodArticulo = '0600301';
        this.vCantidad = 1;
        this.vContramarco = true;
        this.vRampa = 1;
        this.vGuarnicion = false;
        this.vTipoGuarnicion = '';
        this.vTieneReglas = true;
    }

    redimensionarModelo() {
        let vVilaxInfo: VilaxInfo;
        let vGlassInfo: GlassInfo;

        if (this.vListaLuzCapa.length > 0) {
            this.vListaLuzCapa.forEach(CapaTmp => {
                CapaTmp.vAncho1 = this.vAncho1;
                CapaTmp.vAlto1 = this.vAlto1;
                CapaTmp.vAncho2 = 0;
                CapaTmp.vAlto2 = 0;
                if (CapaTmp.vModelo !== undefined) {
                    if (CapaTmp.vModelo.vModelo === 'VILAX') {
                        let vModeloTmp = CapaTmp.vModelo as VilaxInfo;
                        vVilaxInfo = new VilaxInfo();
                        vVilaxInfo.vAncho1 = this.vAncho1;
                        vVilaxInfo.vAlto1 = this.vAlto1;
                        vModeloTmp.vAncho1 = this.vAncho1;
                        vModeloTmp.vAlto1 = this.vAlto1
                        vVilaxInfo.vListaLuzCapa = vModeloTmp.vListaLuzCapa;
                        vVilaxInfo.redimensionarModelo();
                        vModeloTmp.vListaLuzCapa = vVilaxInfo.vListaLuzCapa;
                    } else if (CapaTmp.vModelo.vModelo === 'VIDRIO CORTADO') {
                        let vModeloTmp = CapaTmp.vModelo as GlassInfo;
                        vGlassInfo = new GlassInfo();
                        vGlassInfo.vAncho1 = this.vAncho1;
                        vGlassInfo.vAlto1 = this.vAlto1;
                        vModeloTmp.vAncho1 = this.vAncho1;
                        vModeloTmp.vAlto1 = this.vAlto1;
                        vGlassInfo.vListaServicios = vModeloTmp.vListaServicios;
                        vGlassInfo.redimensionarModelo();
                        vModeloTmp.vListaServicios = vGlassInfo.vListaServicios;
                    }
                }
            });
        }
    }
}